"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordRegex = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
const VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const zod_1 = require("zod");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const query_keys_1 = require("../../../../queries/query-keys");
const sessionQuery_1 = require("../../../../queries/sessionQuery");
const userRepository_1 = __importDefault(require("../../../../repositories/userRepository"));
const Root_1 = require("../../../../router/Root");
const routerUtils_1 = require("../../../../router/routerUtils");
const userSelectors_1 = require("../../../../selectors/userSelectors");
const zustandStore_1 = require("../../../../zustandStore");
const passwordSetupForm_1 = require("../hsbc/steps/defaultRegistration/step_3/passwordSetupForm");
const usePasswordInput_1 = require("../loginform/hooks/usePasswordInput");
const SetupTwoFactorAuth = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./setupTwoFactorAuth'))));
const logger = (0, pino_1.default)();
const lexico = new lexico_1.default();
exports.passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!#$%&()*+,-./:;<=>?@[\\\]^_`{|}~])[\d!#$%&()*+,-./:;<=>?@[\\\]^_`{|}~A-Za-z]{10,}$/;
const activateUserSchema = zod_1.z
    .object({
    username: zod_1.z.email(),
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    password: zod_1.z.string().check(ctx => {
        if (ctx.value.length < 10) {
            ctx.issues.push({
                code: 'custom',
                message: passwordSetupForm_1.passwordRequireMessage,
                input: ctx.value,
            });
        }
        else if (!exports.passwordRegex.test(ctx.value)) {
            ctx.issues.push({
                code: 'custom',
                message: passwordSetupForm_1.passwordRequireMessage,
                input: ctx.value,
            });
        }
    }),
    confirmPassword: zod_1.z.string(),
})
    .check(ctx => {
    if (ctx.value.confirmPassword !== ctx.value.password) {
        ctx.issues.push({
            code: 'custom',
            message: 'The passwords did not match',
            input: ctx.value,
        });
    }
});
const ActivationForm = () => {
    const { invitation, setInvitationFirstName, setInvitationUserName, setInvitationLastName, setInvitationFormLoading, resetInvitationForm, } = (0, zustandStore_1.useZustand)(state => ({ ...state }));
    const { username, firstName, lastName, isFormLoading } = invitation;
    const { state: passwordState, handlePasswordChange, handlePasswordValidation, handleConfirmPasswordValidation, resetPasswordFormState, } = (0, usePasswordInput_1.usePasswordInput)();
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, react_1.useState)(false);
    const { userId, activationToken } = (0, react_router_1.useParams)();
    const activateUser = (0, sessionQuery_1.useActivateUserQuery)();
    const navigate = (0, react_router_1.useNavigate)();
    const { setDialog, closeDialog, setMfaData, setShowTwoFactorAuth, setNotification, registration } = (0, zustandStore_1.useZustand)();
    const { showTwoFactorAuth } = registration;
    const location = (0, react_router_1.useLocation)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: userData, error } = initialData;
    const logout = (0, sessionQuery_1.useSessionLogoutQuery)();
    const theme = (0, material_1.useTheme)();
    const isInvitation = !location.pathname.includes('register');
    const isFormValid = activateUserSchema.safeParse({
        username,
        firstName,
        lastName,
        password: passwordState.passwordValue,
        confirmPassword: passwordState.confirmPasswordValue,
    }).success;
    const { navigateToSigninMessage } = (0, routerUtils_1.useSigninMessageNavigation)();
    const onActivateUser = async () => {
        const user = await userRepository_1.default.getUser();
        Root_1.queryClient.setQueryData([query_keys_1.userKeys.getUser], user);
        const isTsAdmin = (0, userSelectors_1.isSupportAdmin)(user?.roles);
        if (user && !isTsAdmin && !(0, userSelectors_1.isCompanyOrSupportAdmin)(user?.roles) && user?.roles.length === 0) {
            logout.mutate();
            setNotification([
                {
                    type: strings_1.notificationStrings.ERROR,
                    message: lexico.trc('Error message', 'Your account has been disabled, please contact your company or team administrator.'),
                },
            ]);
        }
        else if (isTsAdmin) {
            void navigate('/settings/overview');
        }
        else {
            if ((0, userSelectors_1.isCompanyOrSupportAdmin)(user?.roles || [])) {
                void navigate('/wallet');
            }
            else {
                void navigate('/wallet/my-cards');
            }
        }
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setInvitationFormLoading(true);
        if (!userData) {
            logger.error('User data is missing');
            return;
        }
        const options = {
            activationToken: activationToken || '',
            companyName: userData?.companyName,
            email: userData?.username,
            username: userData?.username,
            firstName, // should get firstName & lastName from zustand instead of userData
            lastName,
            password: passwordState.passwordValue,
            userId: userId || '',
        };
        activateUser.mutate(options, {
            onSuccess: async (data) => {
                setMfaData(data);
                if (data?.mfaOtp?.status === 'setup_required') {
                    setShowTwoFactorAuth(true);
                }
                else {
                    setShowTwoFactorAuth(false);
                    await onActivateUser();
                }
                resetPasswordFormState();
                resetInvitationForm();
            },
            onError: () => {
                setInvitationFormLoading(false);
                setDialog({
                    type: strings_1.notificationStrings.WARNING,
                    message: lexico.trc('Warning message', 'Oh snap! We were not able to create your account.'),
                    open: true,
                    actionText: 'TRY AGAIN',
                    showCancel: false,
                    onAccept: closeDialog,
                });
            },
            onSettled: () => {
                setInvitationFormLoading(false);
            },
        });
    };
    (0, react_use_1.useEffectOnce)(() => {
        if (!error) {
            return;
        }
        navigateToSigninMessage({
            heading: lexico.tr('Sorry, we are having technical difficulties. Please try again later.'),
            message: lexico.trc('Error message', 'The link to activate your account is invalid or has expired. Please check with the person who invited you to get another invitation.'),
        });
    });
    (0, react_1.useEffect)(() => {
        if (userData) {
            if (userData.firstName) {
                setInvitationFirstName(userData.firstName);
            }
            if (userData.lastName) {
                setInvitationLastName(userData.lastName);
            }
            if (userData.username) {
                setInvitationUserName(userData.username);
            }
        }
    }, [userData]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: showTwoFactorAuth ? ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(SetupTwoFactorAuth, {}) }, location.state?.key)) : ((0, jsx_runtime_1.jsxs)("form", { "data-testid": "form", style: {
                padding: `0 ${theme.tsGoUnit.tsUnit} ${theme.tsGoUnit.tsUnit}`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: theme.tsGoUnit.tsUnit,
                marginBottom: 0,
            }, autoComplete: "off", onSubmit: handleSubmit, children: [isInvitation && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", children: (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "Username", style: { padding: 0, margin: 0 }, slotProps: {
                                    inputLabel: {
                                        style: { fontWeight: theme.typography.tsFontWeight.default },
                                    },
                                }, type: "text", required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "off", name: "USER_NAME", value: username, disabled: true }) }), (0, jsx_runtime_1.jsx)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", children: (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "First Name", style: { padding: 0, margin: 0 }, slotProps: {
                                    inputLabel: {
                                        style: { fontWeight: theme.typography.tsFontWeight.default },
                                    },
                                }, type: "text", required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "off", name: "FIRST_NAME", value: firstName, onChange: evt => {
                                    setInvitationFirstName(evt.target.value);
                                } }) }), (0, jsx_runtime_1.jsx)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", children: (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "Last Name", style: { padding: 0, margin: 0 }, slotProps: {
                                    inputLabel: {
                                        style: { fontWeight: theme.typography.tsFontWeight.default },
                                    },
                                }, type: "text", required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "off", name: "LAST_NAME", value: lastName, onChange: evt => {
                                    setInvitationLastName(evt.target.value);
                                } }) })] })), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", error: passwordState.isPasswordError, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { name: "password", label: "Password", style: { padding: 0, margin: 0 }, type: showPassword ? 'text' : 'password', required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "off", onChange: handlePasswordChange, onBlur: handlePasswordValidation, value: passwordState.passwordValue, error: passwordState.isPasswordError, slotProps: {
                                htmlInput: {
                                    'data-testid': 'password',
                                },
                                inputLabel: {
                                    style: { fontWeight: theme.typography.tsFontWeight.default },
                                },
                                input: {
                                    endAdornment: passwordState.passwordValue?.length > 0 ? ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => setShowPassword(prev => !prev), edge: "end", children: showPassword ? (0, jsx_runtime_1.jsx)(Visibility_1.default, { fontSize: "small" }) : (0, jsx_runtime_1.jsx)(VisibilityOff_1.default, { fontSize: "small" }) }) })) : null,
                                },
                            } }), passwordState.isPasswordError && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { style: { marginLeft: 0 }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), ' ', lexico.tr('Must be at least 10 characters, at least one capital letter, one number, and one special character')] }))] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", error: passwordState.isConfirmPasswordError, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { name: "confirm password", label: strings_1.sessionStrings.CONFIRM_PASSWORD, style: { padding: 0, margin: 0 }, type: showConfirmPassword ? 'text' : 'password', required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "off", onChange: handlePasswordChange, onBlur: handleConfirmPasswordValidation, value: passwordState.confirmPasswordValue, error: passwordState.isConfirmPasswordError, slotProps: {
                                htmlInput: {
                                    'data-testid': 'confirm-password',
                                },
                                inputLabel: {
                                    style: { fontWeight: theme.typography.tsFontWeight.default },
                                },
                                input: {
                                    endAdornment: passwordState.confirmPasswordValue?.length > 0 ? ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => setShowConfirmPassword(prev => !prev), edge: "end", children: showConfirmPassword ? (0, jsx_runtime_1.jsx)(Visibility_1.default, { fontSize: "small" }) : (0, jsx_runtime_1.jsx)(VisibilityOff_1.default, { fontSize: "small" }) }) })) : null,
                                },
                            } }), passwordState.isConfirmPasswordError && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { style: { marginLeft: 0 }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), ' ', passwordState.confirmPasswordValue === passwordState.passwordValue
                                    ? lexico.tr('Must be at least 10 characters, at least one capital letter, one number, and one special character')
                                    : lexico.tr('The passwords did not match.')] }))] }), (0, jsx_runtime_1.jsx)(material_1.Button, { style: {
                        width: '100%',
                        fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
                    }, "data-testid": "submit", color: uiConstants_1.UI_BUTTON_PRIMARY, disabled: !isFormValid, type: "submit", loading: isFormLoading, startIcon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), variant: "contained", children: lexico.tr('Next') })] })) }));
};
exports.default = ActivationForm;
